import { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { StudioActionFeedback, reportStudioActionError, studioActionErrorMessage } from './studioActionErrorText';

/**
 * The feedback of a raw API error of a Studio action (`StudioActionError` shows it): the server
 * sentence of an `M24_*` refusal, else the general sentence. It reports each new error once to the
 * console (and Sentry when it has no `M24_*` code). Null while there is no error.
 */
export function useStudioActionFeedback(action: string, error: unknown): StudioActionFeedback | null {
  const intl = useIntl();
  const hasError = error !== undefined && error !== null;

  useEffect(() => {
    if (hasError) {
      reportStudioActionError(action, error);
    }
  }, [action, error, hasError]);

  return useMemo<StudioActionFeedback | null>(
    () => (hasError ? { tone: 'danger', message: studioActionErrorMessage(intl, error) } : null),
    [error, hasError, intl]
  );
}
